export interface Project {
  id: number;
  title: {
    en: string;
    fr: string;
  };
  description: {
    en: string;
    fr: string;
  };
  technologies: string[];
  category: ProjectCategory;
  githubUrl: string;
  demoUrl?: string;
  imageUrl?: string;
  featured: boolean;
  date: {
    en: string;
    fr: string;
  };
}

export type ProjectCategory = 
  | 'web_development' 
  | 'mobile_development'
  | 'data_science'
  | 'design'
  | 'devops'
  | 'software_development';

export interface CategoryInfo {
  id: ProjectCategory;
  name: string;
  nameEn: string;
  technologies: string[];
  color: string;
}

export const categories: CategoryInfo[] = [
  {
    id: 'web_development',
    name: 'Développement Web',
    nameEn: 'Web Development',
    technologies: ['React', 'Node.js', 'Laravel', 'WordPress', 'TypeScript', 'JavaScript', 'HTML/CSS', 'PHP', 'Python', 'RiotJS', 'CSS Bulma', 'API TMDB', 'GSAP', 'Framer Motion', 'MongoDB', 'Express.js', 'AI/ML', 'JWT', 'Socket.io', 'Rich Text Editor', 'PostgreSQL', 'Supabase', 'HTML5', 'CSS3'],
    color: 'from-blue-500 to-cyan-400'
  },
  {
    id: 'mobile_development',
    name: 'Développement Mobile',
    nameEn: 'Mobile Development',
    technologies: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Java', 'Android Studio', 'Android Java'],
    color: 'from-green-500 to-emerald-400'
  },
  {
    id: 'data_science',
    name: 'Data Science',
    nameEn: 'Data Science',
    technologies: ['Python', 'R', 'SQL', 'PowerBI', 'OpenCV', 'NumPy', 'Matplotlib', 'Computer Vision', 'Image Processing'],
    color: 'from-purple-500 to-indigo-400'
  },
  {
    id: 'design',
    name: 'Design & Présentation',
    nameEn: 'Design & Presentation',
    technologies: ['Figma', 'Adobe XD', 'Photoshop', 'Illustrator', 'Canva', 'PDF', 'Blender', 'PowerPoint', 'Design graphique', 'UI/UX', 'Communication orale', 'Ergonomie informatique', 'Gestion de projet', 'SWOT analysis', 'AIDA model', 'Business Frameworks', 'Droit du travail', 'Management', 'Rédaction', 'WCAG'],
    color: 'from-pink-500 to-rose-400'
  },
  {
    id: 'software_development',
    name: 'Développement Logiciel',
    nameEn: 'Software Development',
    technologies: ['Java', 'C', 'Python', 'Java Swing', 'Windows', 'Linux', 'J', 'JQt', 'Cybersecurity', 'AI/ML', 'Natural Language Processing', 'PDF Processing', 'API Integration'],
    color: 'from-orange-500 to-amber-400'
  },
  {
    id: 'devops',
    name: 'DevOps & Cloud',
    nameEn: 'DevOps & Cloud',
    technologies: ['Docker', 'Kubernetes', 'Cybersecurity', 'SQL', 'Django'],
    color: 'from-orange-500 to-amber-400'
  }
];

export const projects: Project[] = [
  {
    id: 33,
    title: {
      en: "BDE FISA - SIF Website",
      fr: "BDE FISA - Site Web SIF"
    },
    description: {
      en: "As a member of the student council (BDE), I developed a web application that allowed the new class to register and pay online for the WEI (Welcome Weekend) we organized. The platform features an elegant and intuitive landing page, user-friendly registration forms with strong UI/UX focus, multiple payment options integration (bank transfer, PayPal), comprehensive admin dashboard with key metrics, and highly customizable user profile interface.",
      fr: "En tant que membre du bureau des étudiants (BDE), j'ai développé une application web qui permettait à la nouvelle promotion de s'inscrire et de payer en ligne pour le WEI (Weekend d'Intégration) que nous avons organisé. La plateforme comprend une landing page élégante et intuitive, des formulaires d'inscription conviviaux avec un fort focus UI/UX, l'intégration de multiples options de paiement (virement bancaire, PayPal), un tableau de bord administrateur complet avec des métriques clés, et une interface de profil utilisateur hautement personnalisable."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["HTML", "CSS", "Node.js", "PostgreSQL", "Supabase", "SQL"],
    category: "web_development",
    githubUrl: "https://github.com/NassimEH/BDE-Website-SIF",
    demoUrl: "https://seminaire-integration-fisa-2025.vercel.app/",
    featured: true,
    date: {
      en: "September 2025 - October 2025",
      fr: "Septembre 2025 - Octobre 2025"
    }
  },
  {
    id: 34,
    title: {
      en: "Frit'Int Website",
      fr: "Site Web Frit'Int"
    },
    description: {
      en: "Website of the Frit'Int club, part of the FISA Student Union, which prepares and serves fries to FISA students during various events throughout the year.",
      fr: "Site web du club Frit'Int, faisant partie de l'Union des Étudiants FISA, qui prépare et sert des frites aux étudiants FISA lors de divers événements tout au long de l'année."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["HTML", "CSS", "JavaScript"],
    category: "web_development",
    githubUrl: "https://github.com/NassimEH/Frit-Int-website",
    demoUrl: "https://frit-int-website.vercel.app/",
    featured: false,
    date: {
      en: "October 2025",
      fr: "Octobre 2025"
    }
  },
  {
    id: 35,
    title: {
      en: "Electrical Company - Website",
      fr: "Site Web Entreprise Électrique"
    },
    description: {
      en: "Creation of a showcase website for an electrical company as part of my freelance web development activity. Built with HTML and CSS.",
      fr: "Création d'un site web vitrine pour une entreprise d'électricité dans le cadre de mon activité freelance de développement web. Construit avec HTML et CSS."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["HTML5", "CSS3"],
    category: "web_development",
    githubUrl: "https://github.com/NassimEH/TrikaEnergie-Website",
    featured: false,
    date: {
      en: "September 2025",
      fr: "Septembre 2025"
    }
  },
  {
    id: 24,
    title: {
      en: "CVision - ATS Resume Analyzer",
      fr: "CVision - Analyseur de CV ATS"
    },
    description: {
      en: "Professional resume analysis tool powered by AI to optimize resumes for Applicant Tracking Systems (ATS). Features keyword analysis, formatting suggestions, compatibility scoring, and industry-specific recommendations. Built with React and integrated AI services for comprehensive resume optimization.",
      fr: "Outil professionnel d'analyse de CV alimenté par IA pour optimiser les CV pour les systèmes de suivi des candidatures (ATS). Comprend l'analyse de mots-clés, des suggestions de formatage, un score de compatibilité et des recommandations spécifiques à l'industrie. Construit avec React et intégré aux services d'IA pour une optimisation complète des CV."
    },
    imageUrl: "/images/projets/cvision-portfolio.png",
    technologies: ["React", "AI/ML", "Natural Language Processing", "TypeScript", "Tailwind CSS", "PDF Processing", "API Integration"],
    category: "software_development",
    githubUrl: "https://github.com/NassimEH/cvision-ats-analyzer",
    demoUrl: "https://cvision-gilt.vercel.app/auth?next=/",
    featured: true,
    date: {
      en: "August 2025",
      fr: "Août 2025"
    }
  },
  {
    id: 23,
    title: {
      en: "AI-Powered MERN Blog Platform",
      fr: "Plateforme de Blog MERN Alimentée par IA"
    },
    description: {
      en: "Full-stack blog platform built with MERN stack (MongoDB, Express.js, React, Node.js) integrated with AI capabilities. Features user authentication, rich text editor, AI-generated content suggestions, real-time comments, and advanced content management system.",
      fr: "Plateforme de blog full-stack construite avec la pile MERN (MongoDB, Express.js, React, Node.js) intégrée avec des capacités d'IA. Comprend l'authentification des utilisateurs, un éditeur de texte riche, des suggestions de contenu générées par IA, des commentaires en temps réel et un système de gestion de contenu avancé."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["MongoDB", "Express.js", "React", "Node.js", "AI/ML", "JWT", "Socket.io", "Rich Text Editor"],
    category: "web_development",
    githubUrl: "https://github.com/NassimEH/ai-mern-blog",
    demoUrl: "https://nassimelh-blog.vercel.app/",
    featured: true,
    date: {
      en: "August 2025",
      fr: "Août 2025"
    }
  },
  {
    id: 22,
    title: {
      en: "Milky Deal - GSAP Animated Website",
      fr: "Milky Deal - Site Web Animé avec GSAP"
    },
    description: {
      en: "Modern e-commerce website built with React and enhanced with GSAP animations. Features smooth transitions, interactive scroll effects, product showcases, and responsive design. Demonstrates advanced frontend development skills with focus on user experience and visual appeal.",
      fr: "Site web e-commerce moderne construit avec React et enrichi d'animations GSAP. Propose des transitions fluides, des effets de défilement interactifs, des vitrines de produits et un design responsive. Démontre des compétences avancées en développement frontend avec un focus sur l'expérience utilisateur et l'attrait visuel."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["React", "GSAP", "TypeScript", "Tailwind CSS", "Framer Motion", "Responsive Design"],
    category: "web_development",
    githubUrl: "https://github.com/NassimEH/milky-deal-gsap",
    featured: true,
    date: {
      en: "August 2025",
      fr: "Août 2025"
    }
  },
  {
    id: 21,
    title: {
      en: "Computer Vision RGB Color Detection",
      fr: "Détection de Couleur RGB par Vision par Ordinateur"
    },
    description: {
      en: "Advanced computer vision application using Python and OpenCV for real-time RGB color detection and analysis. Features sophisticated image processing algorithms, color space conversions, and interactive visualization tools for precise color identification and manipulation.",
      fr: "Application avancée de vision par ordinateur utilisant Python et OpenCV pour la détection et l'analyse de couleurs RGB en temps réel. Comprend des algorithmes sophistiqués de traitement d'image, des conversions d'espaces colorimétriques et des outils de visualisation interactifs pour l'identification et la manipulation précise des couleurs."
    },
    imageUrl: "/placeholder.svg",
    technologies: ["Python", "OpenCV", "NumPy", "Matplotlib", "Computer Vision", "Image Processing"],
    category: "data_science",
    githubUrl: "https://github.com/NassimEH/computer-vision-rgb-detection",
    featured: true,
    date: {
      en: "August 2025",
      fr: "Août 2025"
    }
  },
  {
    id: 1,
    title: {
      en: "WebZTP",
      fr: "WebZTP"
    },
    description: {
      en: "A web interface designed to easily configure a DHCP ZTP (Zero Touch Provisioning) system on specific devices. This platform includes user management with different roles and permissions, a clear and intuitive interface, and a knowledge management system.",
      fr: "Interface web conçue pour configurer facilement un système DHCP ZTP (Zero Touch Provisioning) sur des appareils spécifiques. Cette plateforme inclut une gestion des utilisateurs avec différents rôles et permissions, une interface claire et intuitive, et un système de gestion des connaissances."
    },
    technologies: ["Python", "HTML", "CSS", "JavaScript", "SQL", "Django"],
    category: 'devops',
    githubUrl: "https://github.com/Chadi-Mangle/web-ztp",
    demoUrl: "https://webztp.onrender.com/dashboard/",
    featured: true,
    date: {
      en: "December 2024",
      fr: "Décembre 2024"
    }
  },
  {
    id: 2,
    title: {
      en: "Cybersecurity : A Keylogger in Python",
      fr: "Cybersécurité : Un Keylogger en Python"
    },
    description: {
      en: "A simple keylogger developed in Python for cybersecurity awareness purposes.",
      fr: "Un simple keylogger développé en Python dans un but de sensibilisation à la cybersécurité."
    },
    technologies: ["Python", "Cybersecurity"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/KeyLogger",
    featured: false,
    date: {
      en: "June 2025",
      fr: "Juin 2025"
    }
  },
  {
    id: 3,
    title: {
      en: "Cybersecurity : Password Generator in Python",
      fr: "Cybersécurité : Générateur de mots de passe en Python"
    },
    description: {
      en: "A secure password generator in Python.",
      fr: "Un générateur de mots de passe sécurisés en Python."
    },
    technologies: ["Python", "Cybersecurity"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Password-Generator",
    featured: false,
    date: {
      en: "June 2025",
      fr: "Juin 2025"
    }
  },
  {
    id: 4,
    title: {
      en: "Word Frequency Analyzer in J",
      fr: "Analyseur de fréquence de mots en J"
    },
    description: {
      en: "Small application in J that analyzes a text, counts the most frequent words and displays the top N. Possibility to export to HTML.",
      fr: "Petite application en J qui analyse un texte, compte les mots les plus fréquents et affiche les N premiers. Possibilité d'exporter en HTML."
    },
    technologies: ["J", "JQt"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Word-Frequency-Analyzer-in-J",
    featured: false,
    date: {
      en: "June 2025",
      fr: "Juin 2025"
    }
  },
  {
    id: 5,
    title: {
      en: "First-Year Apprenticeship Defense & Experience Report Presentation",
      fr: "Soutenance première année d'apprentissage & Présentation du rapport d'expérience"
    },
    description: {
      en: "Oral presentation of key takeaways from my first year of apprenticeship, based on a comprehensive written report on my technical missions, contributions and skills developed in cybersecurity and project management.",
      fr: "Présentation orale des points clés de ma première année d'alternance, basée sur un rapport écrit complet sur mes missions techniques, contributions et compétences développées en cybersécurité et gestion de projet."
    },
    technologies: ["Communication orale", "Gestion de projet", "Cybersecurity"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Apprenticeship-Defense-Presentation",
    featured: false,
    date: {
      en: "May 2025",
      fr: "Mai 2025"
    }
  },
  {
    id: 6,
    title: {
      en: "Health Companion Project",
      fr: "Projet Health Companion"
    },
    description: {
      en: "Startup project created as part of the C1-C2 level English course \"Business Initiatives\". It's an international humanitarian health initiative, including strategic elements like SWOT analysis and the AIDA model.",
      fr: "Projet de startup créé dans le cadre du cours d'anglais C1-C2 \"Business Initiatives\". C'est une initiative humanitaire internationale dans le domaine de la santé, incluant des éléments stratégiques comme l'analyse SWOT et le modèle AIDA."
    },
    technologies: ["SWOT analysis", "AIDA model", "Business Frameworks", "Communication orale", "Gestion de projet"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Health-Companion-Project",
    featured: false,
    date: {
      en: "March 2025",
      fr: "Mars 2025"
    }
  },
  {
    id: 7,
    title: {
      en: "WeListen - A Streaming App",
      fr: "WeListen - Une application de streaming"
    },
    description: {
      en: "An interactive web platform for discovering and sharing music, with recommendations based on user preferences. Originally developed as a school project, it became an innovative application that blends music sharing with social interaction.",
      fr: "Une plateforme web interactive pour découvrir et partager de la musique, avec des recommandations basées sur les goûts des utilisateurs. Développée à l'origine comme projet scolaire, elle est devenue une application innovante qui mélange partage musical et interaction sociale."
    },
    technologies: ["React", "HTML", "CSS", "Laravel", "PHP", "MongoDB"],
    category: 'web_development',
    githubUrl: "https://github.com/Chadi-Mangle/welisten",
    demoUrl: "https://welisten-app.netlify.app",
    featured: true,
    date: {
      en: "March 2025",
      fr: "Mars 2025"
    }
  },
  {
    id: 8,
    title: {
      en: "Social Law - Presentation about remote working",
      fr: "Droit social - Présentation sur le télétravail"
    },
    description: {
      en: "Group presentation on the right to telework in France for a social law course. Analysis of advantages (flexibility, cost savings), disadvantages (isolation, blurred boundaries between professional and personal life), and current legal framework.",
      fr: "Présentation de groupe sur le droit au télétravail en France pour un cours de droit social. Analyse des avantages (flexibilité, économies de coûts), des inconvénients (isolement, frontières floues entre vie professionnelle et personnelle), et du cadre juridique actuel."
    },
    technologies: ["PowerPoint", "Communication orale", "Droit du travail"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Teleworking-presentation",
    featured: false,
    date: {
      en: "December 2024",
      fr: "Décembre 2024"
    }
  },
  {
    id: 9,
    title: {
      en: "Word to PDF File Converter",
      fr: "Convertisseur de fichiers Word vers PDF"
    },
    description: {
      en: "Automated program to convert Word files (.doc and .docx) to PDF files. The application automatically creates dedicated folders for results and manages the installation of required dependencies.",
      fr: "Programme automatisé pour convertir des fichiers Word (.doc et .docx) en fichiers PDF. L'application crée automatiquement des dossiers dédiés pour les résultats et gère l'installation des dépendances requises."
    },
    technologies: ["Python"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/WordToPDF-code",
    featured: false,
    date: {
      en: "December 2024",
      fr: "Décembre 2024"
    }
  },
  {
    id: 10,
    title: {
      en: "Creativity x Music Composition",
      fr: "Créativité x Composition musicale"
    },
    description: {
      en: "This project presents the evolution of the creative process in musical composition across different eras, prepared for a C1-C2 English course at Télécom SudParis. It examines the approaches of composers from the classical, romantic and contemporary periods.",
      fr: "Ce projet présente l'évolution du processus créatif dans la composition musicale à travers différentes époques, préparé pour un cours d'anglais C1-C2 à Télécom SudParis. Il examine les approches des compositeurs des périodes classique, romantique et contemporaine."
    },
    technologies: ["PowerPoint", "Communication orale"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Creativity-x-Music",
    featured: false,
    date: {
      en: "November 2024",
      fr: "Novembre 2024"
    }
  },
  {
    id: 11,
    title: {
      en: "Presentation - Domestic violence in the workplace: what to do?",
      fr: "Présentation - Violence domestique au travail : que faire ?"
    },
    description: {
      en: "Group project from a management course on women's rights and how to act as a colleague if you suspect a coworker may be experiencing domestic violence. The goal is to raise awareness and educate employees on recognizing signs of domestic abuse.",
      fr: "Projet de groupe issu d'un cours de management sur les droits des femmes et comment agir en tant que collègue si vous soupçonnez qu'un(e) collègue subit des violences domestiques. L'objectif est de sensibiliser et d'éduquer les employés sur les signes d'abus domestiques."
    },
    technologies: ["PowerPoint", "Communication orale", "Management", "Gestion de projet"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Presentation-Femmes-Entreprise",
    featured: false,
    date: {
      en: "November 2024",
      fr: "Novembre 2024"
    }
  },
  {
    id: 12,
    title: {
      en: "Redesign of the MonChauffeurVIP website",
      fr: "Refonte du site MonChauffeurVIP"
    },
    description: {
      en: "As a freelancer, I participated in the complete redesign of the MonChauffeurVIP website, working on the front-end with the WordPress CMS. I used plugins like Yoast SEO to optimize the site for search engines.",
      fr: "En tant que freelance, j'ai participé à la refonte complète du site MonChauffeurVIP, en travaillant sur le front-end avec le CMS WordPress. J'ai utilisé des plugins comme Yoast SEO pour optimiser le site pour les moteurs de recherche."
    },
    technologies: ["WordPress", "SEO", "HTML", "CSS", "JavaScript"],
    category: 'web_development',
    githubUrl: "https://github.com/NassimEH/MonChauffeurVIP-redesign",
    featured: true,
    date: {
      en: "November 2024",
      fr: "Novembre 2024"
    }
  },
  {
    id: 13,
    title: {
      en: "3D Cyborg",
      fr: "Cyborg 3D"
    },
    description: {
      en: "A 3D model of a cyborg created as part of a group project with Blender.",
      fr: "Un modèle 3D d'un cyborg créé dans le cadre d'un projet de groupe avec Blender."
    },
    technologies: ["Blender"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Le-Cyborg-3D",
    featured: false,
    date: {
      en: "October 2024",
      fr: "Octobre 2024"
    }
  },
  {
    id: 14,
    title: {
      en: "3D Gameboy",
      fr: "Gameboy 3D"
    },
    description: {
      en: "3D model of a Gameboy created with Blender.",
      fr: "Modèle 3D d'une Gameboy créé avec Blender."
    },
    technologies: ["Blender"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Gameboy-3D",
    featured: false,
    date: {
      en: "October 2024",
      fr: "Octobre 2024"
    }
  },
  {
    id: 15,
    title: {
      en: "3D Room",
      fr: "Chambre 3D"
    },
    description: {
      en: "3D model of a bedroom created with Blender (learning shading and materials).",
      fr: "Modèle 3D d'une chambre créé avec Blender (apprentissage du shading et des matériaux)."
    },
    technologies: ["Blender"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Room-3D",
    featured: false,
    date: {
      en: "October 2024",
      fr: "Octobre 2024"
    }
  },
  {
    id: 16,
    title: {
      en: "3D Chairs",
      fr: "Chaises 3D"
    },
    description: {
      en: "3D model of two chairs created with Blender.",
      fr: "Modèle 3D de deux chaises créé avec Blender."
    },
    technologies: ["Blender"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Chairs-3D",
    featured: false,
    date: {
      en: "September 2024",
      fr: "Septembre 2024"
    }
  },
  {
    id: 17,
    title: {
      en: "3D Mug",
      fr: "Mug 3D"
    },
    description: {
      en: "My first 3D modeling project with Blender: a mug. Made thanks to ModelTT (TSP club).",
      fr: "Mon premier projet de modélisation 3D avec Blender: une tasse. Réalisé grâce au ModelTT (club de TSP)."
    },
    technologies: ["Blender"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/mug-3D",
    featured: false,
    date: {
      en: "September 2024",
      fr: "Septembre 2024"
    }
  },
  {
    id: 18,
    title: {
      en: "Snake Game in Python",
      fr: "Jeu Snake en Python"
    },
    description: {
      en: "This project represents my individual effort to create a version of the Snake game in Python. I completed this project during my summer vacation to provide a fun and engaging gaming experience on desktop computers.",
      fr: "Ce projet représente mon effort individuel pour créer une version du jeu Snake en Python. J'ai réalisé ce projet pendant mes vacances d'été pour offrir une expérience de jeu amusante et engageante sur ordinateur."
    },
    technologies: ["Python"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Snake-Python",
    featured: false,
    date: {
      en: "July 2024",
      fr: "Juillet 2024"
    }
  },
  {
    id: 19,
    title: {
      en: "TicTacToe Game in Python",
      fr: "Jeu TicTacToe en Python"
    },
    description: {
      en: "This project represents my individual effort to create a version of the TicTacToe game in Python. I completed this project during my free time to provide a fun and engaging gaming experience on desktop computers.",
      fr: "Ce projet représente mon effort individuel pour créer une version du jeu TicTacToe en Python. J'ai réalisé ce projet pendant mon temps libre pour offrir une expérience de jeu amusante et engageante sur ordinateur."
    },
    technologies: ["Python"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/TicTacToe-Python",
    featured: false,
    date: {
      en: "July 2024",
      fr: "Juillet 2024"
    }
  },
  {
    id: 20,
    title: {
      en: "Designs Photoshop",
      fr: "Designs Photoshop"
    },
    description: {
      en: "Collection of all my designs created with Photoshop during my free time.",
      fr: "Collection de tous mes designs créés avec Photoshop pendant mon temps libre."
    },
    technologies: ["Photoshop", "Design graphique"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Design-Photoshop",
    featured: false,
    date: {
      en: "June 2024",
      fr: "Juin 2024"
    }
  },
  {
    id: 21,
    title: {
      en: "Professional thesis from the end-of-BUT2",
      fr: "Mémoire professionnel de fin de BUT2"
    },
    description: {
      en: "This project represents the report of my end-of-BUT2 internship at Université Paris-Est Créteil, completed at Netopsia as a developer. The internship aimed to enhance my software development skills and apply the theoretical knowledge acquired during my studies.",
      fr: "Ce projet représente le rapport de mon stage de fin de BUT2 à l'Université Paris-Est Créteil, effectué chez Netopsia en tant que développeur. Le stage visait à améliorer mes compétences en développement logiciel et à appliquer les connaissances théoriques acquises pendant mes études."
    },
    technologies: ["Rédaction"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Memoire-Professionnel-BUT2",
    featured: false,
    date: {
      en: "June 2024",
      fr: "Juin 2024"
    }
  },
  {
    id: 22,
    title: {
      en: "Mockups for Netopsia",
      fr: "Maquettes pour Netopsia"
    },
    description: {
      en: "Mockup created for the V2 of the NETOPSIA company website, where I completed my end-of-cycle internship for my DUT in computer science.",
      fr: "Maquette créée pour la V2 du site web de l'entreprise NETOPSIA, où j'ai effectué mon stage de fin de cycle pour mon BUT en informatique."
    },
    technologies: ["Figma", "UI/UX", "Ergonomie informatique", "WCAG"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Wireframe-Figma",
    featured: false,
    date: {
      en: "May 2024",
      fr: "Mai 2024"
    }
  },
  {
    id: 23,
    title: {
      en: "Cinema Website",
      fr: "Site web du Cinéma"
    },
    description: {
      en: "A website on the theme of cinema, developed with the RiotJS framework and the TMDB API.",
      fr: "Un site web sur le thème du cinéma, développé avec le framework RiotJS et l'API TMDB."
    },
    technologies: ["CSS", "RiotJS", "API TMDB", "HTML"],
    category: 'web_development',
    githubUrl: "https://github.com/NassimEH/Site-Web-Cinema",
    demoUrl: "https://nassimeh.github.io/Site-Web-Cinema/",
    featured: false,
    date: {
      en: "April 2024",
      fr: "Avril 2024"
    }
  },
  {
    id: 24,
    title: {
      en: "Solitaire Tic-Tac-Toe mobile game",
      fr: "Jeu mobile Solitaire Tic-Tac-Toe"
    },
    description: {
      en: "A version of the Solitaire Tic-Tac-Toe mobile game, coded in Android Java. My first mobile project.",
      fr: "Une version du jeu Morpion Solitaire mobile, codée en Java Android. Mon premier projet mobile."
    },
    technologies: ["Android Java", "Java", "Android Studio"],
    category: 'mobile_development',
    githubUrl: "https://github.com/NassimEH/Morpion-Solitaire",
    featured: true,
    date: {
      en: "April 2024",
      fr: "Avril 2024"
    }
  },
  {
    id: 25,
    title: {
      en: "Presentation on the topic of muscle hypertrophy",
      fr: "Présentation sur l'hypertrophie musculaire"
    },
    description: {
      en: "A presentation on the topic of muscle hypertrophy, a project completed in the second year of my DUT in computer science as part of a communication course.",
      fr: "Une présentation sur le thème de l'hypertrophie musculaire, projet réalisé en deuxième année de mon BUT en informatique dans le cadre d'un cours de communication."
    },
    technologies: ["PowerPoint", "Communication orale"],
    category: 'design',
    githubUrl: "https://github.com/NassimEH/Hypertrophie-Powerpoint",
    featured: false,
    date: {
      en: "March 2024",
      fr: "Mars 2024"
    }
  },
  {
    id: 26,
    title: {
      en: "Java spreadsheet inspired by Excel",
      fr: "Tableur Java inspiré d'Excel"
    },
    description: {
      en: "A spreadsheet inspired by Excel, developed in Java Swing for the user interface.",
      fr: "Un tableur inspiré d'Excel, développé en Java Swing pour l'interface utilisateur."
    },
    technologies: ["Java", "Java Swing"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Tableur-Java",
    featured: true,
    date: {
      en: "February 2024",
      fr: "Février 2024"
    }
  },
  {
    id: 27,
    title: {
      en: "Pie Charts in Java",
      fr: "Graphiques circulaires en Java"
    },
    description: {
      en: "A Java project using Swing to model database data in the form of a pie chart.",
      fr: "Un projet Java utilisant Swing pour modéliser des données d'une base de données sous forme de graphique circulaire."
    },
    technologies: ["Java", "Java Swing", "UI/UX"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Diagrammes-Java",
    featured: false,
    date: {
      en: "December 2023",
      fr: "Décembre 2023"
    }
  },
  {
    id: 28,
    title: {
      en: "Ergonomic Website",
      fr: "Site Web Ergonomique"
    },
    description: {
      en: "A website where the focus was on the relevance of development choices and the implementation of optimal user ergonomics.",
      fr: "Un site web où l'accent était mis sur la pertinence des choix de développement et la mise en œuvre d'une ergonomie utilisateur optimale."
    },
    technologies: ["HTML", "CSS", "JavaScript", "UI/UX", "Ergonomie informatique"],
    category: 'web_development',
    githubUrl: "https://github.com/NassimEH/Site-Web-Ergonomique",
    featured: false,
    date: {
      en: "October 2023",
      fr: "Octobre 2023"
    }
  },
  {
    id: 29,
    title: {
      en: "The Infinite Dungeon",
      fr: "Le Donjon Infini"
    },
    description: {
      en: "My end-of-first-year project for my DUT in computer science: an RPG-style board game.",
      fr: "Mon projet de fin de première année de BUT en informatique : un jeu de plateau de type RPG."
    },
    technologies: ["Java", "Java Swing"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Donjon-Infini-PT2",
    featured: true,
    date: {
      en: "July 2023",
      fr: "Juillet 2023"
    }
  },
  {
    id: 30,
    title: {
      en: "Dual Boot Windows/Linux",
      fr: "Dual Boot Windows/Linux"
    },
    description: {
      en: "A tutorial created in pairs to set up a Dual Boot with Windows 7 / Arch Linux.",
      fr: "Un tutoriel créé en binôme pour mettre en place un Dual Boot avec Windows 7 / Arch Linux."
    },
    technologies: ["Windows", "Linux"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Dual-Boot",
    featured: false,
    date: {
      en: "February 2023",
      fr: "Février 2023"
    }
  },
  {
    id: 31,
    title: {
      en: "Threecot Website",
      fr: "Site Web Threecot"
    },
    description: {
      en: "A website project for a fictional charitable association dedicated to knitting.",
      fr: "Un projet de site web pour une association caritative fictive dédiée au tricot."
    },
    technologies: ["PHP", "HTML", "CSS"],
    category: 'web_development',
    githubUrl: "https://github.com/NassimEH/Site-Web-Threecot",
    demoUrl: "https://nassimeh.github.io/Site-Web-Threecot/",
    featured: false,
    date: {
      en: "February 2023",
      fr: "Février 2023"
    }
  },
  {
    id: 32,
    title: {
      en: "Battleship",
      fr: "Bataille Navale"
    },
    description: {
      en: "A playable version of Battleship on terminal command line, developed in C.",
      fr: "Une version jouable de la Bataille Navale sur terminal en ligne de commande, développée en C."
    },
    technologies: ["C"],
    category: 'software_development',
    githubUrl: "https://github.com/NassimEH/Bataille-Navale",
    featured: false,
    date: {
      en: "December 2022",
      fr: "Décembre 2022"
    }
  }
];

export interface Experience {
  id: number;
  title: {
    en: string;
    fr: string;
  };
  company: string;
  logo?: string;
  location: {
    en: string;
    fr: string;
  };
  startDate: {
    en: string;
    fr: string;
  };
  endDate: {
    en: string | null;
    fr: string | null;
  };
  description: {
    en: string[];
    fr: string[];
  };
  technologies: {
    en: string[];
    fr: string[];
  };
}

export interface Education {
  id: number;
  degree: {
    en: string;
    fr: string;
  };
  institution: string;
  logo?: string;
  location: {
    en: string;
    fr: string;
  };
  startDate: {
    en: string;
    fr: string;
  };
  endDate: {
    en: string;
    fr: string;
  };
  description?: {
    en: string;
    fr: string;
  };
  awards?: string[];
  websiteUrl?: string;
}

export interface Skill {
  category: {
    en: string;
    fr: string;
  };
  items: string[];
}

export const skills: Skill[] = [
  {
    category: {
      en: "Programming Languages",
      fr: "Langages de programmation"
    },
    items: ["Java", "Python", "C", "HTML", "CSS", "JavaScript", "TypeScript", "PHP", "SQL", "Bash"]
  },
  {
    category: {
      en: "Frontend",
      fr: "Frontend"
    },
    items: ["React", "Vue.js", "Angular", "Redux", "Tailwind CSS", "SASS", "Material UI"]
  },
  {
    category: {
      en: "Backend",
      fr: "Backend"
    },
    items: ["Node.js", "Express", "Django", "REST API"]
  },
  {
    category: {
      en: "Databases",
      fr: "Bases de données"
    },
    items: ["MongoDB", "MySQL", "PostgreSQL", "Firebase", "SQLite"]
  },
  {
    category: {
      en: "Tools & Technologies",
      fr: "Outils & Technologies"
    },
    items: ["Git", "Docker", "Linux", "Windows", "VSCode", "Wireshark", "Office 365", "PowerBI", "StarUML", "WordPress", "Drupal"]
  },
  {
    category: {
      en: "Languages",
      fr: "Langues"
    },
    items: ["Français (Natif)", "Arabe (Natif)", "Anglais (Niveau professionnel)", "Espagnol (Notions)"]
  },
  {
    category: {
      en: "Networks",
      fr: "Réseaux"
    },
    items: ["IP", "Ethernet", "TCP", "UDP", "DNS", "VLAN", "NAT", "FTP", "VPN", "TCP/IP", "OSI"]
  }
];

export const contactInfo = {
  email: "elhaddad.nassimpro@gmail.com",
  phone: "+33 6 99 50 90 52",
  location: "Paris, France",
  linkedin: "https://www.linkedin.com/in/nassim-elhaddad/",
  github: "https://github.com/NassimEH"
};

export interface Testimonial {
  id: number;
  name: string;
  position: string;
  company: string;
  image?: string;
  text: {
    en: string;
    fr: string;
  };
  rating: 1 | 2 | 3 | 4 | 5;
  date: {
    en: string;
    fr: string;
  };
  source: 'linkedin' | 'personal' | 'other';
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Jean Dupont",
    position: "Senior Developer",
    company: "Tech Solutions",
    image: "/testimonials/person1.png",
    text: {
      en: "Nassim is a talented developer with great adaptability. His work on our project has been exemplary, and his technical knowledge has been a major asset for our team.",
      fr: "Nassim est un développeur talentueux avec une grande capacité d'adaptation. Son travail sur notre projet a été exemplaire, et sa connaissance technique a été un atout majeur pour notre équipe."
    },
    rating: 5,
    date: {
      en: "June 2023",
      fr: "Juin 2023"
    },
    source: 'linkedin'
  },
  {
    id: 2,
    name: "Marie Lambert",
    position: "Project Manager",
    company: "Digital Innovations",
    image: "/testimonials/person2.png",
    text: {
      en: "I had the pleasure of working with Nassim on several projects. His rigor, sense of initiative and ability to solve complex problems are impressive.",
      fr: "J'ai eu le plaisir de travailler avec Nassim sur plusieurs projets. Sa rigueur, son sens de l'initiative et sa capacité à résoudre des problèmes complexes sont impressionnants."
    },
    rating: 5,
    date: {
      en: "March 2023",
      fr: "Mars 2023"
    },
    source: 'linkedin'
  },
  {
    id: 3,
    name: "Thomas Mercier",
    position: "CTO",
    company: "WebSphere",
    image: "/testimonials/person3.png",
    text: {
      en: "Nassim demonstrated remarkable expertise in cybersecurity during our collaboration. His methodical approach and passion for security make him an asset for any team.",
      fr: "Nassim a fait preuve d'une expertise remarquable en cybersécurité lors de notre collaboration. Son approche méthodique et sa passion pour la sécurité en font un atout pour n'importe quelle équipe."
    },
    rating: 4,
    date: {
      en: "January 2023",
      fr: "Janvier 2023"
    },
    source: 'linkedin'
  }
];
